import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { ApiSensorLogsService } from './api-call-providers/api-sensor-logs.service';
import { DataCacheService } from './data-cache.service';

/*
  Generated class for the SettingSyncCareSystem provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SensorLogsService {

  constructor(
    private _dataCacheService: DataCacheService,
    private _ApiSensorLogsService: ApiSensorLogsService,
  ) {
  }

  // センサーのログ
  sensorLogsSource = new Subject<any>();
  logs$ = this.sensorLogsSource.asObservable();

  async loadLogs() {
    this._ApiSensorLogsService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.SENSORS_LOGS)
    if (!_data.isExist()) {
      await this.fetchLogs();
      return
    }
    this._ApiSensorLogsService.isLoading = false
    return this.sensorLogsSource.next(_data);
  }

  async fetchLogs(params = {}) {
    let res: any = await this._ApiSensorLogsService.getLogs(params)
    let data = { data: res.list }
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.SENSORS_LOGS, res.list, res.expired)
    }
    this.sensorLogsSource.next(data)
  }

  // センサーの連携ログ
  sensorSyncLogsSource = new Subject<any>();
  syncLogs$ = this.sensorSyncLogsSource.asObservable();

  async loadSyncLogs() {
    this._ApiSensorLogsService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.SENSORS_SYNC_LOGS)
    if (!_data.isExist()) {
      await this.fetchLSyncLogs();
      return
    }
    this._ApiSensorLogsService.isLoading = false
    return this.sensorSyncLogsSource.next(_data);
  }

  async fetchLSyncLogs(params = {}) {
    let res: any = await this._ApiSensorLogsService.getSyncLogs(params)
    let data = { data: res.list }
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.SENSORS_SYNC_LOGS, res.list, res.expired)
    }
    this.sensorSyncLogsSource.next(data)
  }
}



// WEBPACK FOOTER //
// ./src/providers/sensor-logs.service.ts